import { config } from "@/config";
import { resolveAdpStaticAssetUrl } from "../../api/adpDataSources.api";
import { AdpRegisteredSourceDataSource } from "../../api/adpDataSources.types";
import { RegisteredSourcePickerItem } from "../../hooks/useRegisteredDataSources";
import {
    toDataSourceInstanceLabel,
    toDataSourceTypeFormatted,
} from "../../components/sheets/ConfigureDataDestinationSheet/helpers";

export function shouldSkipRegisteredDestinationPicker(
    connectorId: string | undefined,
    groupId?: string
): boolean {
    if (groupId !== 'destinations') return false;

    const normalizedConnector = connectorId?.trim().toLowerCase() ?? '';

    const skipConnectors = ['excel', 's3'];

    return skipConnectors.some(connector =>
        normalizedConnector === connector || normalizedConnector.includes(connector)
    );
}


export function toTitleCase(value: string): string {
    return value.replaceAll(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
}

export function normalizeInstance(value: string | null | undefined): string {
    return value?.trim().toLowerCase() ?? ''
}

export function mapRegisteredSourceToPickerItem(
    source: AdpRegisteredSourceDataSource
): RegisteredSourcePickerItem {
    return {
        id: String(source.source_data_source_id),
        rooId: typeof source.roo_id === 'number' ? source.roo_id : undefined,
        kind: toTitleCase(source.data_source_instance || source.data_source_type || 'Source'),
        connectionName: source.data_source_name,
        image: resolveAdpStaticAssetUrl(config.adpApiUrl, source.image_link),
        username: source.username ?? '',
        password: source.password ?? '',
        databaseName: source.database_name ?? '',
        endpoint: source.endpoint ?? '',
        dataSourceInstance: source.data_source_instance ?? '',
        dataSourceType: source.data_source_type ?? '',
        dataSourceInstanceLabel: toDataSourceInstanceLabel(source.data_source_instance),
        dataSourceTypeFormatted: toDataSourceTypeFormatted(source.data_source_type),
    }
}